import { EventMykissCardClicked } from '../../../interfaces/events';

interface IProps {
  postId: string;
  currentPage: string;
  source: string;
}

export const getCatchCardEventProperties = ({
  postId,
  currentPage,
  source,
}: IProps): EventMykissCardClicked['properties'] => ({
  page: currentPage,
  source,
  source_id: postId,
  target: 'catch',
  target_id: postId,
});
